import React from 'react'
import { Container } from 'react-bootstrap'
import { get } from 'lodash'
import ReactHtmlParser from 'react-html-parser'
import Typography from 'components/atoms/Typography/Typography'

import './VideoYoutube.scss'

function extractYoutubeVideoId(input) {
  if (!input) return ''
  const value = String(input).trim()
  if (!value) return ''
  const patterns = [
    /youtube\.com\/watch\?v=([A-Za-z0-9_-]{11})/,
    /youtu\.be\/([A-Za-z0-9_-]{11})/,
    /youtube(?:-nocookie)?\.com\/embed\/([A-Za-z0-9_-]{11})/,
  ]
  for (let i = 0; i < patterns.length; i += 1) {
    const match = value.match(patterns[i])
    if (match) return match[1]
  }
  if (/^[A-Za-z0-9_-]{11}$/.test(value)) return value
  return ''
}

function VideoYoutube({ data }) {
  const title = get(data, 'title')
  const description = get(data, 'description.value')
  const rawUrls = get(data, 'youtube_urls') || get(data, 'youtube_url') || get(data, 'url')
  const urls = Array.isArray(rawUrls) ? rawUrls : [rawUrls]

  const embedUrls = urls
    .map((url) => extractYoutubeVideoId(url))
    .filter(Boolean)
    .map((videoId) => `https://www.youtube-nocookie.com/embed/${videoId}`)

  if (!embedUrls.length) return null

  return (
    <Container className="video-youtube" fluid>
      <Container>
        {title && <Typography cssClass="video-youtube__title mb-3">{title}</Typography>}
        {description && <div className="video-youtube__description mb-3">{ReactHtmlParser(description)}</div>}
        {embedUrls.map((embedUrl, index) => (
          <div className="video-youtube__ratio" key={embedUrl + index}>
            <iframe
              src={embedUrl}
              title={title || 'Vídeo YouTube'}
              frameBorder="0"
              scrolling="no"
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              referrerPolicy="strict-origin-when-cross-origin"
            />
          </div>
        ))}
      </Container>
    </Container>
  )
}

export default VideoYoutube
